const BS_OBJECT_TYPES = {
  LIVE_SESSION: 'a7b6abc1-4b21-368c-9916-d1793abc0918',
  CALENDAR: '0196655b-f6a4-3874-bc21-801b8c9fdd1a',
  LANGUAGE_VIDEO: '147d1a55-f7b7-3034-9029-658d47382c8f',
  SPONSOR: '17a02494-6f58-3717-bcd6-08f9031b71a7',
  GENALOGY_REVEAL: '3b508fbf-d551-3c54-b3a5-bca56a908bc1',
  VIDEO: '431a5800-2fb3-3b19-9801-23dc4b0ff9a8',
  TIPS_N_TRICKS: '486f38ff-4ffd-3d5f-b23a-4e42218ee944',
  SERIES: '4954f3b1-d436-38d4-92bb-5d0ca7dfb3e5',
  IMAGE: "4da1a812-2b2b-36a7-a321-fea9c9594cb9'",
  RECIPE: '6dc3b561-9345-34ab-a20d-e46453f016b9',
  FASHION_SHOW: '6fa856ac-863a-300c-8cde-c81ee4bca3a5',
  CLASS_SESSION: '7276cabb-407f-3b74-b0dd-5de9361cbc81',
  TRADITIONS_N_HOLIDAYS: '728bb629-7f2f-3629-b364-4ae3d09228aa',
  TAG: '90602a54-e7fb-3b69-8e25-236e50f8f7f5',
  SPEAKERS: "93adf2ed-4ee5-3090-92f5-a36a8a949dd2'",
  HOMELAND_FACT: "aafa9b53-5e55-3e7c-be8b-58f7f70a318d'",
  YOUR_HOMETOWN: 'b8bf0c28-5692-390b-9d36-2cdf01e7d018',
  SECTION: 'ba7d9749-a9b7-3050-86ad-15e1b9f4be7d',
  KEYNOTE_SPEAKER: 'bcbcf774-5699-385b-8802-8c057c373c6a937870',
  VIRTUAL_TOUR: 'd14d41b6-4525-372d-a3e8-9feee2ecf222',
  PAGE: 'e30edf29-8fe1-3857-864d-a0240c664e80',
  EXHIBITOR: 'e3b470da-fdf3-3f89-9eca-f29e304cacd1',
  CREATOR: 'f1294ca7-6946-3a0f-9129-4f35378c0c30',
}
export default BS_OBJECT_TYPES
